/* eslint-disable array-callback-return */
import { treatmentTimeTypes } from '../../../enums/treatmentTimeTypes';
import { mapTimeSlotsMatrix } from '../../../actions/areas/shared/mappingHelper';

export const mapBundleVisit = treatmentInstances => {
  let bundleVisitModel = {};
  const bundleVisitList = [];

  treatmentInstances.forEach(x => {
    bundleVisitModel = {
      treatmentInstanceId: x.treatmentInstanceId,
      treatmentId: x.treatmentId,
      nhsNumber: x.nhsNumber,
      postcode: x.treatmentPostcode,
      multipleVisitsTimeSlotChosen:
        x.treatmentTimeType === treatmentTimeTypes.multiple ? mapTimeSlotsMatrix(x.timeSlots) : [],
    };
    bundleVisitList.push(bundleVisitModel);
  });

  return bundleVisitList;
};

export const mapBundledActivities = treatmentInstances => {
  let activityModel = {};
  const activitiyList = [];

  treatmentInstances.map(x =>
    x.activities.forEach(y => {
      activityModel = {
        treatmentId: x.treatmentId,
        id: y.activityId,
        name: y.name,
        duration: y.duration,
      };
      activitiyList.push(activityModel);
    }),
  );

  return activitiyList.flat();
};
